import { Box, Stack, Typography } from "@mui/material"
import { allColors } from "../../constants"
import { images } from "../../assets"
import ReviewChipCard from "../../components/card/ReviewChipCard"
import { useState } from "react";

const REVIEWS_DATA = [
    {
        image: images.dummyUserImg1,
        name: "Ali Raza",
        designation: "Product Manager",
        rating: 5,
        review: "The team delivered beyond expectations. The UI/UX was intuitive and the performance improvements were noticeable immediately.",
        servicesAccured: ["UI/UX Design", "Web Development"]
    },
    {
        image: images.dummyUserImg1,
        name: "Sarah Khan",
        designation: "Startup Founder",
        rating: 4,
        review: "Great communication and timely delivery. They understood our vision and turned it into a functional product.",
        servicesAccured: ["Web Development", "Q/A Testing"]
    },
    {
        image: images.dummyUserImg1,
        name: "Ahmed Hassan",
        designation: "CTO",
        rating: 5,
        review: "Highly professional team with strong technical expertise. They handled complex requirements very smoothly.",
        servicesAccured: ["Web Development", "API Integration"]
    },
    {
        image: images.dummyUserImg1,
        name: "Fatima Noor",
        designation: "Marketing Lead",
        rating: 4,
        review: "The design quality was top-notch and aligned perfectly with our brand identity. Would definitely work again.",
        servicesAccured: ["UI/UX Design", "Branding"]
    },
    {
        image: images.dummyUserImg1,
        name: "Usman Tariq",
        designation: "E-commerce Owner",
        rating: 5,
        review: "Our website speed and user experience improved drastically after their optimization work.",
        servicesAccured: ["Web Development", "Performance Optimization"]
    },
    {
        image: images.dummyUserImg1,
        name: "Hina Sheikh",
        designation: "HR Manager",
        rating: 4,
        review: "They built a very clean and user-friendly internal system for our team. Support was also very responsive.",
        servicesAccured: ["Web App Development", "Q/A Testing"]
    }
];


const OurReviews = () => {
    const scrollingReviews = [...REVIEWS_DATA, ...REVIEWS_DATA]
    const animationDuration = `${Math.max(REVIEWS_DATA.length * 6, 24)}s`

    const [selectedReview, setSelectedReview] = useState(REVIEWS_DATA[0])

    return (
        <Box
            component={"section"}
            id="development-services"
            bgcolor={allColors.blueBerry}
            borderRadius={3}
            p={{ xs: 2, md: 5 }}
            mt={{ xs: 4, sm: 6, md: 8 }}
        >
            <Typography
                textAlign="center"
                fontFamily="Raleway"
                fontWeight="400"
                color={allColors.white}
                fontSize={{ xs: "35px", md: "50px" }}
            >
                Hear From Our Clients
            </Typography>
            <Typography
                variant="body1"
                textAlign="center"
                fontFamily="Raleway"
                fontWeight="400"
                color={allColors.white}
                maxWidth="600px"
                mx="auto"
            >
                We thoroughly understand the business needs and create experiences
                that align with the required objectives.
            </Typography>
            <Box
                maxWidth={"md"}
                mt={3}
                mx="auto"
                sx={{
                    overflow: "hidden",
                    position: "relative",
                    "@keyframes reviewMarquee": {
                        "0%": { transform: "translateX(0)" },
                        "100%": { transform: "translateX(-50%)" },
                    },
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1.5}
                    sx={{
                        width: "max-content",
                        whiteSpace: "nowrap",
                        animation: `reviewMarquee ${animationDuration} linear infinite`,
                    }}
                >
                    {scrollingReviews.map((review, index) => (
                        <ReviewChipCard
                            key={`${review.name}-${index}`}
                            name={review.name}
                            designation={review.designation}
                            image={review.image}
                            onClick={() => setSelectedReview(review)}
                            selected={selectedReview.name === review.name}
                        />
                    ))}
                </Stack>
            </Box>

            <Box
                mt={3}

                maxWidth={"md"}
                mx="auto"
                sx={{
                    // border: "1px solid rgba(255, 255, 255, 0.18)",
                    // borderRadius: 2,
                    p: { xs: 2, md: 3 },
                    // backgroundColor: "rgba(17, 66, 214, 0.2)",
                }}
            >
                <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <Box
                        sx={{
                            width: { xs: "100%", md: 270 },
                            borderRadius: 2,
                            overflow: "hidden",
                            position: "relative",
                            flexShrink: 0,
                        }}
                    >
                        <Box
                            component="img"
                            src={selectedReview.image}
                            alt={selectedReview.name}
                            sx={{
                                width: "100%",
                                height: "100%",
                                minHeight: { xs: 220, md: 300 },
                                objectFit: "cover",
                            }}
                        />
                        <Box
                            sx={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                backgroundColor: allColors.white,
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: allColors.blueBerry,
                                fontWeight: 700,
                            }}
                        >
                            ▶
                        </Box>
                    </Box>

                    <Box
                        flex={1}
                        sx={{
                            background: "rgba(255, 255, 255, 0.08)",
                            border: "1px solid rgba(255, 255, 255, 0.22)",
                            borderRadius: "14px",
                            backdropFilter: "blur(8px)",
                            WebkitBackdropFilter: "blur(8px)",
                            p: { xs: 1.5, md: 2 },
                        }}
                    >
                        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={1.5}>
                            <ReviewChipCard
                                name={selectedReview.name}
                                designation={selectedReview.designation}
                                image={selectedReview.image}
                                // isSelected
                            />
                            <Box>
                                <Typography color="#F8C542" fontSize="14px">
                                    {"★".repeat(selectedReview.rating)}
                                </Typography>
                                <Typography color={allColors.white} fontSize="13px" mt={0.5}>
                                    Services Acquired
                                </Typography>
                                <Typography color={allColors.white} fontSize="12px" sx={{ opacity: 0.85 }}>
                                    {selectedReview.servicesAccured.join(" • ")}
                                </Typography>
                            </Box>
                        </Stack>

                        <Typography color={allColors.white} fontSize={{ xs: "18px", md: "20px" }} mt={3} mb={1.5}>
                            Words of Appreciation
                        </Typography>
                        <Typography variant="body2" color={allColors.white} sx={{ opacity: 0.9, lineHeight: 1.4 }}>
                            {selectedReview.review}
                        </Typography>
                    </Box>
                </Stack>
            </Box>


        </Box>
    )
}

export default OurReviews;